// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3q","link":"e_4q","imageContainer":"e_5q","author":"e_6q","text":"e_7q","buttonIcon":"e_8q"};